<div class="container module-content content-box">
  <div id="activity1">
    <h2>Activity: Needs vs. Wants: What Do You Think?</h2>

    <p>Put an “A” before items you think are absolutely essential. Put a “B” before those that are important but not essential. Put a “C” before those that could be eliminated if necessary. <b>You may want to use this sheet to start a discussion with other members of your family about needs and wants.</b></p>

    <table class="fillable priority-list table table-borderless table-sm w-auto">
      <tr>
        <td><input type="text" class="form-control" [(ngModel)]="model.priorityList.item1.value" [ngModelOptions]="{standalone: true}" maxlength="1"></td>
        <td>an owned home (not rented)</td>
      </tr>
      <tr>
        <td><input type="text" class="form-control" [(ngModel)]="model.priorityList.item2.value" [ngModelOptions]="{standalone: true}" maxlength="1"></td>
        <td>a pet</td>
      </tr>
      <tr>
        <td><input type="text" class="form-control" [(ngModel)]="model.priorityList.item3.value" [ngModelOptions]="{standalone: true}" maxlength="1"></td>
        <td>money saved for future goals</td>
      </tr>
      <tr>
        <td><input type="text" class="form-control" [(ngModel)]="model.priorityList.item4.value" [ngModelOptions]="{standalone: true}" maxlength="1"></td>
        <td>money saved for emergencies</td>
      </tr>
      <tr>
        <td><input type="text" class="form-control" [(ngModel)]="model.priorityList.item5.value" [ngModelOptions]="{standalone: true}" maxlength="1"></td>
        <td>a radio</td>
      </tr>
      <tr>
        <td><input type="text" class="form-control" [(ngModel)]="model.priorityList.item6.value" [ngModelOptions]="{standalone: true}" maxlength="1"></td>
        <td>a television</td>
      </tr>
      <tr>
        <td><input type="text" class="form-control" [(ngModel)]="model.priorityList.item7.value" [ngModelOptions]="{standalone: true}" maxlength="1"></td>
        <td>cable service or satellite connection</td>
      </tr>
      <tr>
        <td><input type="text" class="form-control" [(ngModel)]="model.priorityList.item8.value" [ngModelOptions]="{standalone: true}" maxlength="1"></td>
        <td>DVD/VCR</td>
      </tr>
      <tr>
        <td><input type="text" class="form-control" [(ngModel)]="model.priorityList.item9.value" [ngModelOptions]="{standalone: true}" maxlength="1"></td>
        <td>recreation that costs money (tickets, bowling, etc.)</td>
      </tr>
      <tr>
        <td><input type="text" class="form-control" [(ngModel)]="model.priorityList.item10.value" [ngModelOptions]="{standalone: true}" maxlength="1"></td>
        <td>new clothes to replace worn out items</td>
      </tr>
      <tr>
        <td><input type="text" class="form-control" [(ngModel)]="model.priorityList.item11.value" [ngModelOptions]="{standalone: true}" maxlength="1"></td>
        <td>new clothes to keep up with the current styles</td>
      </tr>
      <tr>
        <td><input type="text" class="form-control" [(ngModel)]="model.priorityList.item12.value" [ngModelOptions]="{standalone: true}" maxlength="1"></td>
        <td>telephone</td>
      </tr>
      <tr>
        <td><input type="text" class="form-control" [(ngModel)]="model.priorityList.item13.value" [ngModelOptions]="{standalone: true}" maxlength="1"></td>
        <td>cell telephone</td>
      </tr>
      <tr>
        <td><input type="text" class="form-control" [(ngModel)]="model.priorityList.item14.value" [ngModelOptions]="{standalone: true}" maxlength="1"></td>
        <td>vehicle that runs well</td>
      </tr>
      <tr>
        <td><input type="text" class="form-control" [(ngModel)]="model.priorityList.item15.value" [ngModelOptions]="{standalone: true}" maxlength="1"></td>
        <td>vehicle that looks good</td>
      </tr>
      <tr>
        <td><input type="text" class="form-control" [(ngModel)]="model.priorityList.item16.value" [ngModelOptions]="{standalone: true}" maxlength="1"></td>
        <td>two or more vehicles for family use</td>
      </tr>
      <tr>
        <td><input type="text" class="form-control" [(ngModel)]="model.priorityList.item17.value" [ngModelOptions]="{standalone: true}" maxlength="1"></td>
        <td>money for gifts</td>
      </tr>
      <tr>
        <td><input type="text" class="form-control" [(ngModel)]="model.priorityList.item18.value" [ngModelOptions]="{standalone: true}" maxlength="1"></td>
        <td>money for charity</td>
      </tr>
      <tr>
        <td><input type="text" class="form-control" [(ngModel)]="model.priorityList.item19.value" [ngModelOptions]="{standalone: true}" maxlength="1"></td>
        <td>regular medical/dental checkups</td>
      </tr>
      <tr>
        <td><input type="text" class="form-control" [(ngModel)]="model.priorityList.item20.value" [ngModelOptions]="{standalone: true}" maxlength="1"></td>
        <td>newspaper/magazine subscriptions</td>
      </tr>
    </table>

    <p><small><i>Developed by Kathy Prochaska-Cue, Ph.D., A.EC., University of Nebraska-Lincoln Extension, and Jean Chicoine, Ph.D., Nebraska Department of Health and Human Services</i></small></p>

    <h3>Need/Wants Cards</h3>
    <p>Sort the cards by placing each under either the “Needs” or the “Wants” column. If needed, add more cards for possible discussion.</p>

    <div cdkDropListGroup>
      <table #cardsWrapper class="cards table table-borderless">
        <thead>
          <th></th>
          <th><h4>NEEDS</h4></th>
          <th><h4>WANTS</h4></th>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="list-group"
                *ngIf="model.cards.pool as pool"
                cdkDropList
                [cdkDropListData]="pool"
                (cdkDropListDropped)="drop($event)">
                <app-page-activity-card-item *ngFor="let item of pool" [pool]="pool" [item]="item"
                  class="item list-group-item"
                  cdkDrag [cdkDragDisabled]="item.added && item.editing" [cdkDragPreviewContainer]="cardsWrapper"
                >
                  <div class="item list-group-item drag-placeholder" *cdkDragPlaceholder></div>
                </app-page-activity-card-item>
              </div>

              <button type="button" class="btn waves-dark w-100 m-0 mt-3" (click)="addCard()">
                <mdb-icon far icon="plus-square"></mdb-icon><span class="ml-1 nowrap">Add Card</span>
              </button>
            </td>
            <td>
              <div class="list-group"
                *ngIf="model.cards.needs as needs"
                cdkDropList
                [cdkDropListData]="needs"
                (cdkDropListDropped)="drop($event)">
                <app-page-activity-card-item *ngFor="let item of needs" [pool]="needs" [item]="item"
                  class="item list-group-item"
                  cdkDrag [cdkDragDisabled]="item.added && item.editing" [cdkDragPreviewContainer]="cardsWrapper"
                >
                  <div class="item list-group-item drag-placeholder" *cdkDragPlaceholder></div>
                </app-page-activity-card-item>
              </div>
            </td>
            <td>
              <div class="list-group"
                *ngIf="model.cards.wants as wants"
                cdkDropList
                [cdkDropListData]="wants"
                (cdkDropListDropped)="drop($event)">
                <app-page-activity-card-item *ngFor="let item of wants" [pool]="wants" [item]="item"
                  class="item list-group-item"
                  cdkDrag [cdkDragDisabled]="item.added && item.editing" [cdkDragPreviewContainer]="cardsWrapper"
                >
                  <div class="item list-group-item drag-placeholder" *cdkDragPlaceholder></div>
                </app-page-activity-card-item>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <p><small><i>This worksheet was modified by Kathy Prochaska-Cue, Ph.D., A.EC., University of Nebraska-Lincoln Extension, and Jean Chicoine, Ph.D.,Nebraska Department of Health and Human Services with permission from the University of Minnesota.</i></small></p>

    <div *ngIf="flag" style="color:red" class="mt-5 warning">
      You must complete the above activities before moving on
    </div>
  </div>
</div>

<div class="container navigate-buttons">
  <button type="button" class="btn waves-dark w-25" (click)="goBack($event)"><i class="fas fa-angle-left mr-3"></i>{{backTitle}}</button>
  <button *ngIf="previewByAdmin || !delay || activityOneCompleted()" type="button" class="btn waves-dark w-25" (click)="goNext($event) && resetFlag()">{{nextTitle}}<i class="fas fa-angle-right ml-3"></i></button>
  <button *ngIf="!(previewByAdmin || !delay || activityOneCompleted())" type="button" class="btn waves-dark w-25" (click)="setFlag()" style="background-color: #ffd782;">{{nextTitle}}<i class="fas fa-angle-right ml-3"></i></button>
</div>
